export default "__VITE_ASSET__lnVusYRO__"